// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { fetchByRemoteIdFlat } from 'crm_data/owners/OwnersAPI';
export const getOwnerByUserId = ({
  userId
}) => fetchByRemoteIdFlat(userId);